/**
 * Avatar display component
 */
import './Avatar.css';

interface AvatarProps {
  src?: string;        // Data URL or URL
  displayName: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
}

export function Avatar({ src, displayName, size = 'medium', onClick }: AvatarProps) {
  const initial = displayName ? displayName.charAt(0).toUpperCase() : '?';

  return (
    <div
      className={`avatar avatar-${size}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
      title={displayName}
    >
      {src ? (
        <img src={src} alt={displayName} />
      ) : (
        <span className="avatar-initial">{initial}</span>
      )}
    </div>
  );
}
